import { Injectable, inject } from '@angular/core';
import { BackendDataSourceService } from '@ntap/core';
import { TreeNode } from 'primeng/api'; // PrimeNG TreeNode interface
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RokoviCuvanjaService {
  private backendService = inject(BackendDataSourceService);

  constructor() {}

  getRetentionPeriods(): Observable<TreeNode[]> {
    // Poziva backend servis da dobije podatke
    return this.backendService
      .getViewData('rok_cuvanja_dropdown', {})
      .pipe(map((value: any[]) => this.buildTreeNodes(value)));
  }

  private buildTreeNodes(data: any[]): TreeNode[] {
    const nodes: TreeNode[] = [];
    const lookup: { [data: string]: TreeNode } = {};
    const firstnode: TreeNode = {
      data: null,
      label: 'Prva razina',
      children: []
    };
    nodes.push(firstnode);

    // Kreiraj sve čvorove u obliku objekta, bez children poveznica
    data.forEach((item) => {
      const id = item.$itemType + '~id';
      const label = item.$itemType + '~naziv';
      const parent_id = item.$itemType + '~parent_id';
      const node: TreeNode = {
        data: item[id],
        label: item[label],
        children: []
      };
      lookup[item[id]] = node;

      // Ako je parent_id null, dodaj u root nivo
      if (!item[parent_id]) {
        nodes.push(node);
      }
    });

    // Poveži children s parentima
    data.forEach((item) => {
      const parent_id = item.$itemType + '~parent_id';
      const id = item.$itemType + '~id';
      if (item[parent_id]) {
        const parent = lookup[item[parent_id]];
        if (parent) {
          parent.children = parent.children || [];
          parent.children.push(lookup[item[id]]);
        }
      }
    });

    return nodes;
  }
}
